import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Typography,
  SvgIcon,
  Box,
  makeStyles,
  TextField,
  CircularProgress,
  Grid,
  FormControl,
  FormHelperText,
  InputAdornment,
} from "@material-ui/core";
import {
  AddCircleOutline,
  ChevronRight,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
  KeyboardSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import MandatorySpan from "../sasl/models/MandatorySpan";
import { Autocomplete } from "@material-ui/lab";
import axios from "axios";
import { appUrl, smlUrl } from "../../../../../utils/config";
import jwtDecode from "jwt-decode";
import SearchIcon from "@material-ui/icons/Search";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../containers/actions/types";
import { useDispatch } from "react-redux";
import BackDropLoading from "../models/BackDrop";
import DocumentAccessDialog from "./DocumentAccessDialog";

const useStyles = makeStyles((theme) => ({
  select: {
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingTop: "10px",
      paddingBottom: "10px",
      minWidth:'80px'
    },
  },
  captionSty:{display: 'flex',alignItems: 'center',cursor: 'pointer','&:hover': {
    textDecoration: 'underline',
  }
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  }
}));

const DraggableTableRow = ({
  row,
  handleDelete,
  handleRequirementChange,
  handleStakeholderTypeChange,
  handleSignatureChange,
  userOptions,
  handleUserChange,
  deliverablesData,
  error
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: row.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const classes = useStyles();

  const internalOrg =
    localStorage.collabType === "CMO"
      ? deliverablesData.cdmoOrgID
      : deliverablesData.sponsorOrgID;

  const externalOrg =
    localStorage.collabType === "CMO"
      ? deliverablesData.sponsorOrgID
      : deliverablesData.cdmoOrgID;

  return (
    <TableRow ref={setNodeRef} style={style} {...attributes}>
      <TableCell>
        {row.editFlag ? (
          <FormControl  error={error && row.requirement==='NA'? true: false}>
          <Select
            variant="outlined"
            value={row.requirement}
            className={classes.select}
            onChange={(e) => handleRequirementChange(row.id, e.target.value)}
            helper
            fullWidth
          >
            <MenuItem value="NA">NA</MenuItem>
            <MenuItem value="Review">Review</MenuItem>
            <MenuItem value="Approve">Approve</MenuItem>
            </Select>
            {error && row.requirement === 'NA' && <FormHelperText>Select Requirement</FormHelperText>}
          </FormControl>
        ) : (
          row.requirement
        )}
      </TableCell>
      <TableCell>
        {row.editFlag ? (
          <FormControl  error={error && row.stakeholderType==='NA'? true: false}>
          <Select
            variant="outlined"
            className={classes.select}
            value={row.stakeholderType}
            onChange={(e) =>
              handleStakeholderTypeChange(row.id, e.target.value)
            }
            fullWidth
          >
            <MenuItem value="NA">NA</MenuItem>
            <MenuItem value="Internal">Internal</MenuItem>
            <MenuItem value="External">External</MenuItem>
            </Select>
            {error && row.stakeholderType === 'NA' && <FormHelperText>Select Stakeholder type</FormHelperText>}
            </FormControl>
        ) : (
          row.stakeholderType
        )}
      </TableCell>
      <TableCell>
        {row.editFlag ? (
          <Autocomplete
            size="small"
            fullWidth
            variant="outlined"
            name="teamLead"
            options={
              row.stakeholderType === "NA"
                ? []
                : row.stakeholderType === "Internal"
                ? userOptions.filter((val) => val.orgId === internalOrg)
                : userOptions.filter((val) => val.orgId === externalOrg)
            }
            getOptionLabel={(option) =>
              option.userName ? `${option.userName}(${option.roleName})` : ""
            }
            value={row.teamMember}
            onChange={(event, value) => {
              handleUserChange(row.id, value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label=""
                placeholder="Search or select team member"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                error={error && (row.teamMember === '' || row.teamMember === null )? true:false}
                helperText={error && (row.teamMember === '' || row.teamMember === null )?'Select Assigned team member':''}
              />
            )}
          />
        ) : row.teamMember ? (
          `${row.teamMember.userName} (${row.teamMember.roleName})`
        ) : (
          "NA"
        )}
      </TableCell>
      <TableCell>
      <FormControl  error={error && row.signature==='NA'? true: false}>
        <Select
          variant="outlined"
          className={classes.select}
          value={row.signature}
          onChange={(e) => handleSignatureChange(row.id, e.target.value)}
          fullWidth
        >
          <MenuItem value="NA">NA</MenuItem>
          <MenuItem value="Digital">Digital</MenuItem>
          <MenuItem value="Electronic">Electronic</MenuItem>
          </Select>
          {error && row.signature === 'NA' && <FormHelperText>Select Signature</FormHelperText>}
          </FormControl>
      </TableCell>
      {row.editFlag ? (
        <TableCell align="center" {...listeners}>
          <i className="fa fa-arrows-alt" />
        </TableCell>
      ) : (
        <TableCell></TableCell>
      )}
      <TableCell>
        {row.editFlag && (
          <IconButton onClick={() => handleDelete(row.id)}>
            <DeleteIcon />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

const DraggableDialogTable1 = ({ open, handleClose, deliverablesData, handleReviewApproveSuccess, document }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [rows, setRows] = useState([
    {
      id: "1",
      requirement: "Approval - SME",
      stakeholderType: "External",
      teamMember: deliverablesData.sponsorSMESignatoryID,
      signature: "Digital",
      editFlag: false,
    },
    {
      id: "2",
      requirement: "Approval - QA",
      stakeholderType: "External",
      teamMember: deliverablesData.sponsorQASignatoryID,
      signature: "Digital",
      editFlag: false,
    },
  ]);
  const [userDetails, setUserDetails] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [tableError, setTableError] = useState(false);
  const [error, setError] = useState({
    error: false,
    errorMessages:''
  });

  const [openAccessSetting, setOpenAccessSetting] = useState(false)

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    const { collabType } = localStorage;
    const tokenData = jwtDecode(localStorage.getItem("authToken"));
    let data = {
      organizationId:
        collabType === "CMO"
          ? tokenData.organization_id
          : deliverablesData.sponsorOrgID,
    };
    axios
      .post(`${smlUrl}/user/getUsersByOrg`, data)
      .then((res) => {
        //console.log(res.data.data);
        if (res.data.status) {
          setTableLoading(false);
          setUserDetails(res.data.data);
          setRows(
            rows.map((val) => {
              return {
                ...val,
                teamMember:
                  res.data.data &&
                  res.data.data.filter((data) => data.userId === val.teamMember)
                    .length > 0
                    ? // `${res.data.data.filter((data) => data.userId === val.teamMember)[0].userName} (${res.data.data.filter((data) => data.userId === val.teamMember)[0].roleName})`
                      res.data.data.filter(
                        (data) => data.userId === val.teamMember
                      )[0]
                    : "NA",
              };
            })
          );
        } else {
          setTableError(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);
        setTableError(true);
      });
  }, []);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = rows.findIndex((row) => row.id === active.id);
      const newIndex = rows.findIndex((row) => row.id === over.id);
      setRows((items) => arrayMove(items, oldIndex, newIndex));
    }
  };

  const handleDeleteRow = (id) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  const handleAddRow = () => {
    setError({
      error: false,
      errorMessages:''
    })
    const newRow = {
      id: `${rows.length + 1}`,
      requirement:
        localStorage.collabType !== "Pharma Co" ? "Approve" : "Review",
      stakeholderType:
        localStorage.collabType !== "Pharma Co" ? "Internal" : "External",
      teamMember: "",
      signature: "NA",
      editFlag: true,
    };

    // const rowData = rows.unshift(newRow)
    // setRows(rows.unshift(newRow))
    // console.log(rows.unshift(newRow))
    setRows((prevRows) => [newRow,...prevRows]);
  };

  const handleRequirementChange = (id, value) => {
    setError({
      error: false,
      errorMessages:''
    })
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, requirement: value } : row
      )
    );
  };

  const handleStakeholderTypeChange = (id, value) => {
    setError({
      error: false,
      errorMessages:''
    })
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, stakeholderType: value } : row
      )
    );
  };

  const handleSignatureChange = (id, value) => {
    setError({
      error: false,
      errorMessages:''
    })
    setRows((prevRows) =>
      prevRows.map((row) => {
        // row.id === id ? { ...row, signature: value } : row
    return { ...row, signature: value }
      }
        
      )
    );
  };

  const handleUserChange = (id, value) => {
    setError({
      error: false,
      errorMessages:''
    })
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, teamMember: value } : row
      )
    );
  };

  const handleSendForApproval = () => {
    const res = rows.filter(
      (val) =>
        val.requirement === "NA" ||
        val.teamMember === "" ||
        val.stakeholderType === "NA"
    );
    if (res.length > 0) {
      // let errorMessages = []
      // res.forEach((val) => {
      //   if (val.requirement === "NA") {
      //     errorMessages.push('Enter the Requirement')
      //   }
      //   if (val.stakeholderType === "NA") {
      //     errorMessages.push('Enter the Stakeholder type')
      //   }
      //   if (val.teamMember === "") {
      //     errorMessages.push('Enter the Assigned team member')
      //   }
      //   if (val.signature === "NA") {
      //     errorMessages.push('Enter the Signature')
      //   }
      // })
      setError({
        error: true,
        errorMessages:'Please select required fields'
      })
    } else {
      const data = rows.map((val, index) => {
        if (val.id === "1" || val.id === "2") {
          return {
            requirementType: "Approve",
            stakeHolderType: val.stakeholderType,
            teamMember: val.teamMember.emailAddress,
            signature: val.signature,
            order: index + 1,
          };
        } else {
          return {
            requirementType: val.requirement,
            stakeHolderType: val.stakeholderType,
            teamMember: val.teamMember.emailAddress,
            signature: val.signature,
            order: index + 1,
          };
        }
      });

      //console.log(data);
      //console.log(document)
      const requestObj = {
        collabrixFileID: document.collabrixFileID,
        fileName: document.fileName,
        versionNumber: document.data.versionNumber,
        uploadRemarks: document.data.uploadRemarks,
        projectName: deliverablesData.projectName,
          sponsorOrgId: deliverablesData.sponsorOrgID,
          cmoOrgId: deliverablesData.cdmoOrgID,
          workflowDetails:data,
      }
      //console.log(requestObj)

      dispatch({
        type: OPEN_BACKDROP,
      });
      // handleClose()
      // setTimeout(() => {
      //   dispatch({
      //     type: DESTROY_BACKDROP,
      //   });
      //   handleReviewApproveSuccess('reviewApprovalSaved')
      //   // setError({
      //   //   error: true,
      //   //   errorMessages:'Something went wrong. Please try again.'
      //   // })
      // },[3000])
       axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addWorkflowDetails`,
          requestObj
        )
        .then((res) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          if (res.data.status) {
            handleReviewApproveSuccess('reviewApprovalSaved')
          } else {
            setError({
              error: true,
              errorMessages:'Something went wrong. Please try again.'
            })
          }
        })
        .catch((err) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          //console.log(err);
          setError({
            error: true,
            errorMessages:'Something went wrong. Please try again.'
          })
        });
    }
  };

  const handleAccessSetting = () => {
    setOpenAccessSetting(!openAccessSetting)
  }

  return (
    <React.Fragment>
    <Dialog
      open={open}
      onClose={handleClose}
      style={{ borderRadius: "1rem" }}
      maxWidth="lg"
      fullWidth
      disableBackdropClick // Disable closing on outside click
      disableEscapeKeyDown // Disable closing on escape key
    >
      <BackDropLoading/>
      <Typography
        style={{
          fontSize: "2rem",
          fontWeight: 500,
          padding: "2rem",
          paddingBottom: "1rem",
        }}
      >
        Define review/approval workflow
      </Typography>
      {error.error && (
        <Grid container item alignItems="center" justifyContent="center">
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "50px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              width: "50%",
            }}
          >
          <Typography style={{ textAlign: "center" }}>
            {error.errorMessages}
          </Typography>
          </div>
        </Grid>
      )}
      <div style={{ padding: "1rem 2rem" }}>
        {/* <div style={{display:'flex', justifyContent:'space-between'}}> */}
        <Typography style={{ fontWeight: 500, marginBottom: "10px" }}>
          Workflow details
          <MandatorySpan />
          </Typography>
          {/* <Typography
              variant='caption'
              color='secondary'
              className={classes.captionSty}
              onClick = {handleAccessSetting}
            >
              Click here to view/change document access settings
            </Typography>
          </div> */}
        <TableContainer component={Paper} style={{ maxHeight: 330 }}>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={rows.map((row) => row.id)}
              strategy={verticalListSortingStrategy}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Requirement</TableCell>
                    <TableCell>Stakeholder type</TableCell>
                    <TableCell>Assigned team member</TableCell>
                    <TableCell>Signature</TableCell>
                    <TableCell>Change order</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableLoading ? (
                    <TableRow style={{ height: 150 }}>
                      <TableCell colSpan={6}>
                        <div style={{ textAlign: "center" }}>
                          <CircularProgress color="primary" />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : tableError ? (
                    <TableRow
                      style={{
                        border: "2px solid #FF0000",
                        backgroundColor: "#FFF0F0",
                      }}
                    >
                      <TableCell colSpan={6} align="center">
                        Something went wrong. Please try again later.
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row) => (
                      <DraggableTableRow
                        key={row.id}
                        row={row}
                        handleDelete={handleDeleteRow}
                        handleRequirementChange={handleRequirementChange}
                        handleStakeholderTypeChange={
                          handleStakeholderTypeChange
                        }
                        handleSignatureChange={handleSignatureChange}
                        userOptions={userDetails}
                        handleUserChange={handleUserChange}
                        deliverablesData={deliverablesData}
                        error={error.error}
                      />
                    ))
                  )}
                </TableBody>
              </Table>
            </SortableContext>
          </DndContext>
        </TableContainer>
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-start",
            margin: "1rem 0rem",
          }}
        >
          <Button
            variant="outlined"
            startIcon={<AddCircleOutline />}
            style={{ textTransform: "none", borderRadius: "20px" }}
            onClick={handleAddRow}
          >
            Add new row
          </Button>
        </Box>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "2rem",
          paddingTop: "1rem",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          endIcon={<ChevronRight />}
          style={{ borderRadius: "20px", textTransform: "none" }}
          onClick={handleSendForApproval}
        >
          Save and send for review/approval
        </Button>
      </div>
      </Dialog>
      {openAccessSetting &&
        <DocumentAccessDialog open={openAccessSetting} handleClose={handleAccessSetting} classes={classes} />
      }
      </React.Fragment>
  );
};

export default DraggableDialogTable1;
